import { type AccessDeclaration, requireRole } from '../access';

/**
 * Who may open Day close — its reasoning is on the route's entry in
 * `route-table.tsx`. Here rather than inline so the open-days warning in the
 * back-office shell asks the same question of the same declaration: the shell
 * cannot import the route table, which imports the shell.
 */
export const dayCloseAccess: AccessDeclaration = requireRole('OWNER', 'MANAGER');
